//  plain js
window.onload = function(){
    removeUnderscores();
    initLoadMoreBlogs();
    showAdditionalInfo();
    addQuantityInputs();
    outOfStockButton();
}

function outOfStockButton() {
    // Select all out-of-stock product list items
    var outOfStockProducts = document.querySelectorAll(".snize-product-out-of-stock");
  
    outOfStockProducts.forEach(function (product) {
      // Find the button inside each out-of-stock product
      var button = product.querySelector(".snize-view-product-button");
      if (button) {
        button.textContent = "Out of Stock";
        button.disabled = true; // optionally disable the button
        button.classList.add("out-of-stock-button");
      }
    });
};

// When clicking quantity stop it from redirecting to pdp
document.addEventListener('click', function(e) {
  if (
    e.target.classList.contains('increment-qty') ||
    e.target.classList.contains('decrement-qty') ||
    e.target.closest('input[name="quantity"]')
  ) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
});

// 1) inject +/– and number input
function addQuantityInputs() {
  document.querySelectorAll('.snize-button.snize-action-button.snize-add-to-cart-button').forEach(button => {
    if (!button.parentElement.querySelector('.quantity-wrapper')) {
      const quantityWrapper = document.createElement('div');
      quantityWrapper.className = 'quantity-wrapper flex items-center gap-2 mt-2';

      const mkButton = (text, className, onClick) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.textContent = text;
        b.className = className;
        b.addEventListener('click', onClick);
        return b;
      };

      const decrementButton = mkButton('–',
        'decrement-qty border border-black rounded w-8 h-8 flex items-center justify-center text-lg',
        () => {
          let inp = quantityWrapper.querySelector('input');
          inp.value = Math.max(1, parseInt(inp.value) - 1 || 1);
        }
      );

      const quantityInput = document.createElement('input');
      quantityInput.type = 'number';
      quantityInput.name = 'quantity';
      quantityInput.value = '1';
      quantityInput.min = '1';
      quantityInput.className = 'border border-black rounded w-12 h-8 text-center';

      const incrementButton = mkButton('+',
        'increment-qty border border-black rounded w-8 h-8 flex items-center justify-center text-lg',
        () => {
          let inp = quantityWrapper.querySelector('input');
          inp.value = parseInt(inp.value) + 1;
        }
      );

      quantityWrapper.appendChild(decrementButton);
      quantityWrapper.appendChild(quantityInput);
      quantityWrapper.appendChild(incrementButton);

      button.parentElement.insertBefore(quantityWrapper, button);
    }
  });
}

// run on load + observe
addQuantityInputs();
new MutationObserver(addQuantityInputs).observe(document.body, { childList: true, subtree: true });


// 2) intercept the Add-to-basket click in capture phase, then custom-add with quantity
document.addEventListener('click', async function(e) {
  if (!e.target.classList.contains('snize-add-to-cart-button')) return;

  e.preventDefault();
  e.stopImmediatePropagation(); // block Snize’s own handler

  const button = e.target;
  const card = button.parentElement;
  const qtyInput = card.querySelector('input[name="quantity"]');
  const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

  // derive handle from surrounding <a class="snize-view-link" href="…/products/HANDLE">
  const link = button.closest('a.snize-view-link');
  if (!link) return console.error('No product link found');
  const m = link.getAttribute('href').match(/\/products\/([^\/?#]+)/);
  if (!m) return console.error('Cannot parse product handle from', link.href);
  const handle = m[1];

  try {
    // fetch product JSON to get a variant ID
    const pd = await fetch(`/products/${handle}.js`).then(r=>r.json());
    // choose first available variant (or just first)
    const variant = pd.variants.find(v=>v.available) || pd.variants[0];
    if (!variant) throw new Error('No variant found');

    // add to cart with quantity
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity }] })
    });
    const data = await res.json();
    console.log('Added to cart:', data);
    // you can now refresh drawer or update cart-count etc.

  } catch(err) {
    console.error('Error adding to cart:', err);
  }

}, true);  // ← capture phase so we beat Snize’s own listener

const showAdditionalInfo = () => {
    let recipes_article_cross = document.querySelectorAll(".recipes_article_cross");
    recipes_article_cross.forEach(cross => {
        cross.addEventListener("click", () => {
            let container = cross.closest(".recipe_container");
            if(container.classList.contains("active")){
                container.classList.remove("active");
            } else {
                container.classList.add("active");
            }
        });
    });
  }
// remove hyphens 
const removeUnderscores  = () => {
    setTimeout( () => {
      let text = document.querySelectorAll(".hyphen_text");
    
      text.forEach(a =>{
        if(a !== undefined || a !== null){
          a.innerHTML = a.innerHTML.split("_").join(" ");
          console.log('hyphen update')
        }
      });
    }, 1000);
}
/* load more function */
const loadMore = (load_more_btn, container, items) => {
    let products_on_page = document.querySelector(container);
    let next_url = products_on_page.dataset.nextUrl;
    
    if(products_on_page != null || products_on_page != undefined){
    $.ajax({
        url: next_url,
        type: "GET",
        dataType: "html",
        beforeSend: function(){
            load_more_btn.style.display = "none";
        }
    }).done(function(next_page){
        let new_products = $(next_page).find(container);
        let new_url = new_products.data("next-url");

        if(new_url){
            load_more_btn.style.display = "flex";
        }
        products_on_page.dataset.nextUrl = new_url;   
        products_on_page.innerHTML += new_products[0].innerHTML;
        console.log(new_products[0]);
        num_of_products_on_page = document.querySelectorAll(items);
    }); 
    setTimeout(() => {
        removeUnderscores();
    }, 500);
    }
}

/* initLoadMoreBlogs */
const initLoadMoreBlogs = () => {
    let loadMoreBlogsButton = document.querySelector(".load_more_blogs_btn");
    if(loadMoreBlogsButton != null && loadMore != undefined){
        loadMoreBlogsButton.addEventListener("click", () => {
            loadMore(loadMoreBlogsButton, '.blog-posts-on-page', '.blog-post');
        });
    }   
}

/* scroll to top (collection page) */
const scrollToTop = (scrollLocation) => {
    let scrollToTopButton = document.querySelector(scrollLocation);
    if(scrollToTopButton != null || scrollToTopButton != undefined){
      scrollToTopButton.addEventListener("click", () =>{
        window.scrollTo({top: 0, behavior: 'smooth'});
      });
    }
  }

  // mobile menu open close next side child menu
var mobile_menu_parent = document.querySelectorAll('li.parent p')
var mobile_menu_parent_next = document.querySelectorAll('li.parent.mobile p')
var mobile_menu_firstLayer_parent_next = document.querySelectorAll('li.parent.mobile_first_layer p')
var mobile_menu_back = document.querySelectorAll('.mobile-back')

// mobile menu open/close

document.querySelector('.mobile-menu-icon').addEventListener('click', () => {
    document.querySelector('.mobile-menu-container').classList.toggle('left-0')
    document.querySelector('.mobile-menu-container').classList.toggle('-left-full')
    for (let i = 0; i < (mobile_menu_back.length); i++) {
        mobile_menu_back[i].classList.remove('-left-full')
        mobile_menu_back[i].classList.remove('pointer-events-none')

     }

});
document.querySelector('.mobile-close-icon').addEventListener('click', () => {
    document.querySelector('.mobile-menu-container').classList.toggle('left-0')
    document.querySelector('.mobile-menu-container').classList.toggle('-left-full')
    for (let i = 0; i < (mobile_menu_back.length); i++) {
        mobile_menu_back[i].classList.add('-left-full')
        mobile_menu_back[i].classList.add('pointer-events-none')

     }
});

 for (let i = 0; i < mobile_menu_parent.length; i++) {
     mobile_menu_parent[i].addEventListener("click", () => {
       mobile_menu_parent[i].parentElement.children[1].classList.toggle('left-0')
       mobile_menu_parent[i].parentElement.children[1].classList.toggle('-left-full')
     });
 }

//  first layer of mobile menu

 for (let i = 0; i < mobile_menu_firstLayer_parent_next.length; i++) {
      mobile_menu_firstLayer_parent_next[i].addEventListener("click", () => {
    mobile_menu_firstLayer_parent_next[i].nextElementSibling.lastElementChild.classList.toggle('flex')
    console.log(mobile_menu_firstLayer_parent_next[i].nextElementSibling.lastElementChild)
    });
}

//  anything furhter than the first layer of menu items

 for (let i = 0; i < mobile_menu_parent_next.length; i++) {
    mobile_menu_parent_next[i].addEventListener("click", () => {
      mobile_menu_parent_next[i].parentElement.parentElement.children[1].classList.toggle('left-0')
      mobile_menu_parent_next[i].parentElement.parentElement.children[1].classList.toggle('-left-full')
      mobile_menu_parent_next[i].parentElement.parentElement.parentElement.classList.remove('overflow-y-scroll')
      console.log(mobile_menu_parent_next[i].parentElement.parentElement.children[1].lastElementChild.classList.toggle('flex'))
    });
}

 for (let i = 0; i < (mobile_menu_back.length); i++) {
    mobile_menu_back[i].addEventListener("click", () =>  {
    mobile_menu_back[i].parentElement.classList.toggle('left-0')
    mobile_menu_back[i].parentElement.classList.toggle('-left-full')
    mobile_menu_back[i].classList.toggle('flex')
    mobile_menu_back[i].parentElement.parentElement.parentElement.classList.add('overflow-y-scroll')
})
 }

//  scroll behaviour for curved line

document.addEventListener('scroll', () => {
    if (window.scrollY > 0) {
        // document.querySelector('.curve').classList.add('scale-0')
        // remove curve
        document.querySelector('.curve').classList.add('h-0')
        document.querySelector('.curve').classList.remove('h-12')
        document.querySelector('.header-desk-nav li.desk-logo').classList.add('-my-6')
        document.querySelector('.header-desk-nav li.desk-logo').classList.remove('-mb-10')
        document.querySelector('.header-desk-nav li.desk-logo').classList.remove('-mt-1')
        // document.querySelector('.header-desk-nav').style.height = '105px'
        // document.querySelector('.header-desk-nav li.desk-logo').classList.remove('-mb-4')
        document.querySelector('.header-desk-nav li.desk-logo img').classList.remove('scale-90')
        document.querySelector('.header-desk-nav li.desk-logo img').classList.add('scale-6')
        document.querySelector('.header-desk-nav').classList.add('pb-2px')
        document.querySelector('.header-desk-nav').classList.add('pt-1px')
    } else {
        // add curve
        document.querySelector('.header-desk-nav').classList.remove('pb-2px')
        document.querySelector('.header-desk-nav').classList.remove('pt-1px')
        document.querySelector('.header-desk-nav li.desk-logo').classList.add('-mb-10')
        document.querySelector('.header-desk-nav li.desk-logo').classList.add('-mt-1')
        document.querySelector('.header-desk-nav li.desk-logo').classList.remove('-my-6')
        document.querySelector('.curve').classList.add('h-12')
        document.querySelector('.curve').classList.remove('h-0')
        document.querySelector('.header-desk-nav li.desk-logo img').classList.add('scale-90')
        document.querySelector('.header-desk-nav li.desk-logo img').classList.remove('scale-6')
    }
})

// hover behaviour megamenu

const CloseAllDropdowns = () => {
    var elems = document.querySelectorAll('.mega-dropdown')
    for (let i = 0;i<elems.length;i++) {
        elems[i].classList.remove('flex')
        elems[i].classList.add('hidden')
    }

}

// loop over all menu items that have the dropdown class (this means they have a mega menu of some type)
// add event listeners to open and close the mega menus
// no manual change needed if client adds new menus - :) 
var dropdownContainer = document.querySelector('.mega-container')
let dropdownMenus = document.querySelectorAll('.dropdown-menu')
let dropdownMegas = document.querySelectorAll('.mega-dropdown')

// Update your hover behavior to be more reliable
for (let i = 0; i < dropdownMenus.length; i++) {
  dropdownMenus[i].addEventListener('mouseenter', () => {
    CloseAllDropdowns();
    document.querySelector('.mega-container').classList.remove('hidden');
    dropdownMegas[i].classList.add('flex');
    dropdownMegas[i].classList.remove('hidden');
    
    // Force reflow to prevent animation glitches
    void dropdownMegas[i].offsetWidth;
  });

  dropdownMegas[i].addEventListener('mouseleave', () => {
    dropdownMegas[i].classList.add('hidden');
    dropdownMegas[i].classList.remove('flex');
    document.querySelector('.mega-container').classList.add('hidden');
  });
}

let desk_navNonDropdown = document.querySelectorAll('.header-desk-nav li.non-dropdown')

for (let i = 0; i < desk_navNonDropdown.length;i++) {
    desk_navNonDropdown[i].addEventListener('mouseover', () => {
        dropdownContainer.classList.add('hidden')
        CloseAllDropdowns()
    })
}

document.querySelectorAll('.grandchild a').forEach(link => {
  link.style.pointerEvents = 'auto';
  link.style.position = 'relative';
  link.style.zIndex = '1000';
});

// recipe cta action

// let recipe_cta_cross = document.querySelectorAll('.recipe_cross')
// console.log(recipe_cta_cross.length)
// for (let i = 0;i < recipe_cta_cross.length; i++) {
//     recipe_cta_cross[i].addEventListener('click', () => {
//         console.log(recipe_cta_cross[i].parentNode.parentNode)
//         recipe_cta_cross[i].parentNode.parentNode.querySelector('.recipe_cta').classList.toggle('overflow-hidden')
//         recipe_cta_cross[i].parentNode.parentNode.querySelector('.recipe_cta').classList.toggle('h-0')
//         recipe_cta_cross[i].parentNode.parentNode.querySelector('.recipe_cta').classList.toggle('py-2')
//         recipe_cta_cross[i].classList.toggle('rotate-45')
//     })
// }

// recipe cta action

let recipe_top = document.querySelectorAll('.recipe_top')

for (let i = 0;i < recipe_top.length; i++) {
    recipe_top[i].addEventListener('click', () => {

        recipe_top[i].parentNode.querySelector('.recipe_cta').classList.toggle('overflow-hidden')
        recipe_top[i].parentNode.querySelector('.recipe_cta').classList.toggle('h-0')
        recipe_top[i].parentNode.querySelector('.recipe_cta').classList.toggle('py-4')
        recipe_top[i].children[0].classList.toggle('rotate-45')
    })
}

// scroll top functionality
let scrollTopItems = document.querySelectorAll('.scrollTop')
for (let i = 0; i < scrollTopItems.length; i++) {
scrollTopItems[i].addEventListener('click', () => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera 
})
}

// product chevron select change

let productSelects = document.querySelectorAll("select.product-select");

const onClickOutside = (e) => {
    if (!e.target.classList.contains('product-select')) {
     for (let i = 0; i < productSelects.length; i++) {
    productSelects[i].parentElement.querySelector('.chevron-select').classList.remove('scale-y-100');
    productSelects[i].parentElement.querySelector('.chevron-select').classList.add('-scale-y-100');
}
    }
  };

  window.addEventListener("click", onClickOutside);

for (let i = 0; i < productSelects.length; i++) {
  productSelects[i].addEventListener("click", () => {
    productSelects[i].parentElement.querySelector('.chevron-select').classList.add('scale-y-100');
    productSelects[i].parentElement.querySelector('.chevron-select').classList.remove('-scale-y-100');

  });
}

for (let i = 0; i < productSelects.length; i++) {
    productSelects[i].addEventListener("change", () => {
      productSelects[i].parentElement.querySelector('.chevron-select').classList.remove('scale-y-100');
      productSelects[i].parentElement.querySelector('.chevron-select').classList.add('-scale-y-100');
  
    });
  }

// faq actions

let faq_items = document.querySelectorAll('.faq-container div.faq')
if (faq_items) {
console.log(faq_items.length)
for (let i = 0;i < faq_items.length; i++) {
    faq_items[i].addEventListener('click', () => {
        let parent = faq_items[i]; // Get the parent element
        parent.querySelector('.faq-body').classList.toggle('h-0')
        parent.querySelector('.faq-body').classList.toggle('pt-3')
        parent.querySelector('.faq-body').classList.toggle('pb-6')
       parent.querySelector('.faq-body').classList.toggle('opacity-0')
        parent.querySelector('div span').classList.toggle('rotate-45')
    })
}
}

// amisa hover hide parent element slideshow item

amisaItems = document.querySelectorAll('.amisa-hover')

for (let i = 0;i < amisaItems.length; i++) {
    amisaItems[i].addEventListener('mouseenter', () => {
        if (window.innerWidth > 768) {
        amisaItems[i].parentElement.querySelector('svg').classList.add('opacity-0')
        amisaItems[i].parentElement.querySelector('img').classList.add('opacity-0')
        }
    })
    amisaItems[i].addEventListener('mouseleave', () => {
        if (window.innerWidth > 768) {
        amisaItems[i].parentElement.querySelector('svg').classList.remove('opacity-0')
        amisaItems[i].parentElement.querySelector('img').classList.remove('opacity-0')
        }
    })
}


// our mission video behaviour on click

let videoPlayButton = document.querySelectorAll('.play_button')

if (videoPlayButton.length > 0) {

let videoIframe = document.querySelectorAll('.youtube_video')
let videoIframeClose = document.querySelectorAll('.youtube_video_close')
let videoIframeOverlay = document.querySelector('.page-overlay')

for (let i = 0; i < videoPlayButton.length; i++) {

videoPlayButton[i].addEventListener('click', () => {
videoIframe[i].classList.remove('hidden')
videoIframeClose[i].classList.remove('hidden')
videoIframeOverlay.classList.remove('invisible')
videoIframeOverlay.classList.remove('opacity-0')
videoIframeOverlay.classList.add('opacity-70')
document.querySelector('body').classList.add('overflow-y-hidden')
document.querySelector('html').classList.add('overflow-y-hidden')
var iframeSrc = videoIframe[i].src;
var newIframeSrc = iframeSrc.replace(/autoplay=0/, 'autoplay=1');

videoIframe[i].src = newIframeSrc;
})

}

for (let i = 0; i < videoIframeClose.length; i++) {

videoIframeClose[i].addEventListener('click', () => {
videoIframe[i].classList.add('hidden')
videoIframeClose[i].classList.add('hidden')
videoIframeOverlay.classList.add('invisible')
videoIframeOverlay.classList.add('opacity-0')
videoIframeOverlay.classList.remove('opacity-70')
document.querySelector('body').classList.remove('overflow-y-hidden')
document.querySelector('html').classList.remove('overflow-y-hidden')

var iframeSrc = videoIframe[i].src;
var newIframeSrc = iframeSrc.replace(/autoplay=1/, 'autoplay=0');

videoIframe[i].src = newIframeSrc;
})

}


videoIframeOverlay.addEventListener('click', () => {

    for (let i = 0; i < videoIframe.length; i++) {
    videoIframe[i].classList.add('hidden')
    videoIframeClose[i].classList.add('hidden')
}
    videoIframeOverlay.classList.add('invisible')
    videoIframeOverlay.classList.add('opacity-0')
    videoIframeOverlay.classList.remove('opacity-70')
    document.querySelector('body').classList.remove('overflow-y-hidden')
    document.querySelector('html').classList.remove('overflow-y-hidden')
    var iframeSrc = videoIframe[i].src;
var newIframeSrc = iframeSrc.replace(/autoplay=1/, 'autoplay=0');

videoIframe[i].src = newIframeSrc;
    })

}

// shipping cart title behaviour
var cartContentEmptyTitle = document.querySelector('.cart_empty')
var cartContentWithProductsTitle = document.querySelector('.cart_with_products')
let cartSubtotalPrice = document.querySelector('.go-cart-drawer__subtotal-price.js-go-cart-drawer-subtotal')
let cartCheckoutBtn = document.querySelector('.go-cart__checkout')

// Select the node that will be observed for mutations
const targetNode = document.getElementsByClassName('go-cart-drawer__subtotal')[0];

// Options for the observer (which mutations to observe)
const config = {attributes:true, childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = function(mutationsList, observer) {
    // Use traditional 'for loops' for IE 11
    for(const mutation of mutationsList) {
        if (mutation.type === 'attributes') {
        //    check 
        if (document.getElementsByClassName('go-cart-drawer__subtotal')[0].classList.contains('is-invisible')) {
            console.log('empty')
            cartCheckoutBtn.classList.add('pointer-events-none')
            cartCheckoutBtn.classList.add('btn-disabled')
            cartCheckoutBtn.classList.remove('bg-customCheckoutGold')
            cartCheckoutBtn.classList.add('btn-disabled')
            cartContentEmptyTitle.classList.remove('hidden')
            cartContentWithProductsTitle.classList.add('hidden')
            // update price as this isn't updated by go-cart when cart becomes empty
            cartSubtotalPrice.innerHTML = '£0.00'
            
        } else {
            cartContentWithProductsTitle.classList.remove('hidden')
            cartContentEmptyTitle.classList.add('hidden')
            cartCheckoutBtn.classList.remove('pointer-events-none')
            cartCheckoutBtn.classList.add('bg-customCheckoutGold')
            cartCheckoutBtn.classList.remove('btn-disabled')
        }
        }
    }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);


// windows / mac css differences

//Windows
if (navigator.userAgent.indexOf("Win") != -1){
    document.querySelector('.search-input-header__desktop').classList.remove('pt-1')
  }
//Mac
//   else if (navigator.userAgent.indexOf("Mac") != -1){
//     document.getElementsByTagName("body")[0].classList.add("mac");
//   }

// timeline heading move above arrows so that we don't have to use absolute positioning and guess what title they'll have (spacing required)
const timelineHeading = document.querySelector('.timeline_heading')

const limitedInterval = setInterval(() => {
  if (document.querySelector('.timeline_slide_splide')) {
    document.querySelector('.timeline_slide_splide').prepend(timelineHeading);  
    clearInterval(limitedInterval);
  }
}, 500);

// limiter
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-quantity]').forEach(function(wrapper) {

    const input = wrapper.querySelector('[data-quantity-input]');
    const btnAdd = wrapper.querySelector('[data-quantity-add]');
    const btnSubtract = wrapper.querySelector('[data-quantity-subtract]');

    if (!input) return;

    const max = input.dataset.maxPerOrder ? parseInt(input.dataset.maxPerOrder) : null;

    // lock quantity to never allow value above max
    function enforceLimit() {
      const current = parseInt(input.value);

      if (max && current > max) {
        input.value = max;
      }
    }

  
    const observer = new MutationObserver(enforceLimit);
    observer.observe(input, { attributes: true, childList: false, subtree: false });

    // Add button click override
    if (btnAdd) {
  btnAdd.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation(); 
    const current = parseInt(input.value);

    if (max && current >= max) {
      input.value = max;
      enforceLimit();
      return alert('You can only order a maximum of ' + max + ' for this product.');
    }

    input.value = current + 1;
    enforceLimit();
  }, true);
}

    // Subtract button works normally
    if (btnSubtract) {
      btnSubtract.addEventListener('click', function() {
        const current = parseInt(input.value);
        if (current > 1) input.value = current - 1;
      });
    }

    // Lock the input on every manual change too
    input.addEventListener('change', enforceLimit);
    input.addEventListener('input', enforceLimit);

  });
});